import Vue from "vue";
import "./plugins/axios";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ElementUI from 'element-ui';                      // 引入element-ui
import 'element-ui/lib/theme-chalk/index.css';           // element-ui的css样式要单独引入
//百度地图
import BaiduMap from 'vue-baidu-map'

Vue.use(BaiduMap, {
    /* 需要注册百度地图开发者来获取你的ak */
    ak: 'l7ZckLQN8AtGpF4QYUCsZ3mzqkHwjG9c2'
})

Vue.config.productionTip = false;

Vue.use(ElementUI);   // 这种方式引入了ElementUI中所有的组件

new Vue({
    router,
    store,
    render: (h) => h(App),
}).$mount("#app");
